import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import QrCodeRoundedIcon from '@mui/icons-material/QrCodeRounded';

import { useModal } from '../../../hooks/useModal';

import AutoSaveTextField from '../../AutoSaveTextField';
import BarcodeReaderModal from '../../BarcodeReaderModal';

const UpdateReferenceInputComponent = ({ value, disabled, handleUpdate, onFormChange }) => {
    const { t } = useTranslation();

    const [isOpened, toggleModal] = useModal(false);

    const [isError, setIsError] = useState(false);

    const handleBlur = event => {
        const newValue = event.target.value;
        const isEmpty = !newValue;

        if (isEmpty !== isError) {
            setIsError(isEmpty);
        }

        if (isEmpty) {
            onFormChange?.({ externalReference: '' });
            return;
        }

        handleUpdate('basicInformation', {
            basicInformation: {
                externalReference: newValue,
            },
        });
    };

    const handleResult = result => {
        if (!!result && isOpened) {
            handleUpdate('basicInformation', {
                basicInformation: {
                    externalReference: result,
                },
            });
            toggleModal();
        }
    };

    return (
        <>
            <AutoSaveTextField
                error={isError || !value}
                required
                value={value}
                disabled={disabled}
                InputProps={{
                    endAdornment: <QrCodeRoundedIcon onClick={toggleModal} />,
                }}
                label={t('report.form.reference')}
                onBlur={handleBlur}
                onKeyPress={event => {
                    event.key === 'Enter' && handleBlur(event);
                }}
                fullWidth
            />
            <BarcodeReaderModal isOpen={isOpened} handleModalClose={toggleModal} handleResult={handleResult} />
        </>
    );
};

const UpdateReferenceInput = memo(UpdateReferenceInputComponent);

export default UpdateReferenceInput;
